import { render, staticRenderFns } from "./blockJobFair.vue?vue&type=template&id=03c8c3d1&scoped=true"
import script from "./blockJobFair.vue?vue&type=script&lang=js"
export * from "./blockJobFair.vue?vue&type=script&lang=js"
import style0 from "./blockJobFair.vue?vue&type=style&index=0&id=03c8c3d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_064421c868bf9d44c080cdd6f5d40e10/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c8c3d1",
  null
  
)

export default component.exports